/*jshint globalstrict: false*/

import Vue from 'vue';
import CoffeeDetailHome from '../components/home/coffee-detail-home';
import axios from 'axios';

Vue.component('coffee-detail-home', CoffeeDetailHome);

document.addEventListener('DOMContentLoaded', () => {
    Vue.use({
        install (Vue) {
            Vue.prototype.$thirdPartyApi = axios.create({});

            const csrfToken = document.querySelector("meta[name=csrf-token]").content;
            axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;

            Vue.prototype.$api = axios.create({
                baseURL: '/'
            });
        }
    });

    new Vue({
        el: '[data-behavior="coffee-detail-home-vue"]',
    });
});
